import { useLocation, useNavigate } from 'react-router-dom';

import styled, { css, useTheme } from 'styled-components';

import CoreSvg from 'shared/CoreSvg';

import { nav_list } from './data';

const Gnb = () => {
	// const { DEFAULT_CARDINAL, DEFAULT_MISSION } = useGetConfig();
	const DEFAULT_CARDINAL = 1;
	const DEFAULT_MISSION = 1;
	const navigate = useNavigate();
	const location = useLocation();
	const theme = useTheme();

	const isSelected = (url_arr: string) => location.pathname.includes(url_arr);

	return (
		<GnbWrapper>
			<NavList>
				{nav_list.map((item, idx) => (
					<NavItem
						key={item.name}
						onClick={() => {
							if (!item.open) return;
							const targetUrl = item.url(DEFAULT_CARDINAL, DEFAULT_MISSION);
							if (location.pathname !== targetUrl) navigate(targetUrl);
							if (item._onClick) item._onClick();
						}}
						selected={isSelected(item.include)}
					>
						<IconWrapper>
							<CoreSvg
								_fill={item.open ? theme.colors.gray.gray60 : theme.colors.gray.gray15}
							>
								{item.icon}
							</CoreSvg>
						</IconWrapper>

						{item.name}
					</NavItem>
				))}
			</NavList>
		</GnbWrapper>
	);
};

const GnbWrapper = styled.nav`
	width: 80px;
	height: 100%;
	padding: 32px 12px;

	border-right: 1px solid ${({ theme }) => theme.colors.gray.gray15};
`;

const NavList = styled.ul`
	width: 100%;
	height: 100%;

	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 24px;
`;

const NavItem = styled.li<{ selected: boolean }>`
	width: 68px;
	height: 56px;

	${({ theme }) => theme.typo.body.span_bold};

	${({ theme }) => theme.common.flexBetween};
	flex-direction: column;

	cursor: pointer;

	${({ selected, theme }) =>
		selected &&
		css`
			& > div {
				background-color: ${theme.colors.gray.gray_black};
			}

			& > div > span > svg {
				fill: ${theme.colors.gray.gray_white};
			}
		`}
`;

const IconWrapper = styled.div`
	width: 100%;
	height: 32px;
	border-radius: 16px;
	background-color: transparent;

	${({ theme }) => theme.common.flexCenter};
`;

export default Gnb;
